<template>


<section class="kc-elm kc-css-94538 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-288710 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div data-kc-equalheight="true" data-kc-row-action="true" data-kc-equalheight-align="middle" class="kc-elm kc-css-488157 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-838131 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_mltttl  kc-elm kc-css-31286 ">
                           <h2 class="wr deb derb dea dera none nonea"><span class="t1">The</span><span class="t2"> latest</span><span class="t3"> works</span></h2>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-502316 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_btn kc-elm kc-css-429506  "><a class="ssc_button none" href="#"><span>View all</span></a></div>
                     </div>
                  </div>
               </div>
               <div class="kc-elm kc-css-16357 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-6057 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class=" type6 mo  none kc-elm kc-css-663497 ssc_img_ef">
                           <div class="iw"><a href="/" title="" target="_self" class="openlink open_custom_link"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/29.jpg" alt="" src="../../assets/images/29.jpg"></a></div>
                           <div class="ieslide">
                              <div><a href="/" title="" target="_self" class="openlink open_custom_link"><strong>Web design company site</strong></a><a href="/" title="" target="_self" class="rm openlink open_custom_link">View</a></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-108394 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class=" type6 mo  none kc-elm kc-css-115052 ssc_img_ef">
                           <div class="iw"><a href="/" title="" target="_self" class="openlink open_custom_link"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/152.jpg" alt="" src="../../assets/images/152.jpg"></a></div>
                           <div class="ieslide">
                              <div><a href="/" title="" target="_self" class="openlink open_custom_link"><strong>Web design company site</strong></a><a href="/" title="" target="_self" class="rm openlink open_custom_link">View</a></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-440836 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class=" type6 mo  none kc-elm kc-css-213588 ssc_img_ef">
                           <div class="iw"><a href="/" title="" target="_self" class="openlink open_custom_link"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/190.jpg" alt="" src="../../assets/images/190.jpg"></a></div>
                           <div class="ieslide">
                              <div><a href="/" title="" target="_self" class="openlink open_custom_link"><strong>Web design company site</strong></a><a href="/" title="" target="_self" class="rm openlink open_custom_link">View</a></div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="kc-elm kc-css-551298 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-308640 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class=" type6 mo  none kc-elm kc-css-613757 ssc_img_ef">
                           <div class="iw"><a href="/" title="" target="_self" class="openlink open_custom_link"><img class=" lazyloaded" data-src="../../assets/images/28298.jpg" alt="" src="../../assets/images/28298.jpg"></a></div>
                           <div class="ieslide">
                              <div><a href="/" title="" target="_self" class="openlink open_custom_link"><strong>Web design company site</strong></a><a href="/" title="" target="_self" class="rm openlink open_custom_link">View</a></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-816406 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class=" type6 mo  none kc-elm kc-css-178978 ssc_img_ef">
                           <div class="iw"><a href="/" title="" target="_self" class="openlink open_custom_link"><img class=" lazyloaded" data-src="../../assets/images/89666.jpg" alt="" src="../../assets/images/89666.jpg"></a></div>
                           <div class="ieslide">
                              <div><a href="/" title="" target="_self" class="openlink open_custom_link"><strong>Web design company site</strong></a><a href="/" title="" target="_self" class="rm openlink open_custom_link">View</a></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-734256 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class=" type6 mo  none kc-elm kc-css-652371 ssc_img_ef">
                           <div class="iw"><a href="/" title="" target="_self" class="openlink open_custom_link"><img class=" lazyloaded" data-src="../../assets/images/94109.jpg" alt="" src="../../assets/images/94109.jpg"></a></div>
                           <div class="ieslide">
                              <div><a href="/" title="" target="_self" class="openlink open_custom_link"><strong>Web design company site</strong></a><a href="/" title="" target="_self" class="rm openlink open_custom_link">View</a></div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "Works",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Works"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-4{width:33.3333%;}
.kc_col-sm-6{width:50%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
body div.kc_row_inner[data-kc-equalheight=true]{width:calc(100% + 30px);flex-wrap:wrap;}
body div[data-kc-equalheight-align=middle]>.kc_column_inner>.kc_wrapper{display:-webkit-flex!important;display:-ms-flexbox!important;display:flex!important;flex-wrap:wrap;height:100%;width:100%;}
body div[data-kc-equalheight-align=middle]>.kc_column_inner>.kc_wrapper{align-content:center;justify-content:center;align-items:center;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
.entry-content a{box-shadow:none;}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
section{display:block;}
strong{font-weight:700;}
img{border:0;max-width:100%;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
a.ssc_button{position:relative;display:inline-block;transition:all 300ms ease-in;overflow:hidden;}
a.ssc_button span{position:relative;z-index:5;display:inline-block;}
.ssc_btn:after{content:"";display:block;clear:both;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
body .ssc_img_ef{overflow:hidden;position:relative;width:auto;transition:all 300ms ease-in;display:table;}
.ssc_img_ef:hover{z-index:9;}
.ssc_img_ef img{display:inline;transition:all 400ms;margin-bottom:-8px;}
.ssc_img_ef>div{overflow:hidden;display:table-cell;width:100%;height:100%;}
.ssc_img_ef .rm{transition:all 300ms ease-in;}
.ssc_img_ef strong{display:inline-block;}
.ssc_img_ef a strong{text-decoration:none;transition:all 300ms ease-in;}
.ssc_img_ef .ieslide{position:absolute;z-index:2;bottom:0;left:0;right:0;height:auto;width:auto;transition:all 200ms ease-in;}
.ssc_img_ef.type6{width:auto;text-align:center;}
.ssc_img_ef.type6 .ieslide{top:0;text-align:center;}
.ssc_img_ef.type6 strong{display:block;}
.ssc_img_ef.type6 .ieslide{transform:scale(0,0);transition:all 400ms;}
.ssc_img_ef.type6:hover .ieslide{transform:scale(1);}
.ssc_img_ef .rm{display:inline-block;}
.ieslide a{text-decoration:none;}
.ssc_mltttl>h2{display:inline-block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-838131{width:50%;}
body.kc-css-system .kc-css-502316{width:50%;}
body.kc-css-system .kc-css-6057{width:33.33%;}
body.kc-css-system .kc-css-108394{width:33.33%;}
body.kc-css-system .kc-css-440836{width:33.33%;}
body.kc-css-system .kc-css-308640{width:33.33%;}
body.kc-css-system .kc-css-816406{width:33.33%;}
body.kc-css-system .kc-css-734256{width:33.33%;}
}
body.kc-css-system .kc-css-94538{background:#2b2f30 url(../../assets/images/Works_bak.jpg) center center/cover no-repeat scroll;padding-top:125px;padding-bottom:135px;}
body.kc-css-system .kc-css-31286{display:inline-block;}
body.kc-css-system .kc-css-31286 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-31286 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-31286 .t1{color:#ffffff;}
body.kc-css-system .kc-css-31286 .t2{color:#ED7D31;}
body.kc-css-system .kc-css-31286 .t3{color:#ffffff;}
body.kc-css-system .kc-css-429506.ssc_btn{text-align:right;}
body.kc-css-system .kc-css-429506 .ssc_button{color:#ffffff;font-family:Catamaran;font-size:16px;line-height:45px;font-weight:600;text-decoration:none;border:2px solid #ED7D31;border-radius:30px 30px 30px 30px;padding-right:80px;padding-left:80px;}
body.kc-css-system .kc-css-429506{text-align:center;}
body.kc-css-system .kc-css-429506 .ssc_button:hover{color:#ffffff;background-color:#222222;border:2px solid #222222;}
body.kc-css-system .kc-css-16357{padding-top:50px;}
body.kc-css-system .kc-css-663497{box-shadow:0px 16px 50px 0px rgba(0, 0, 0, 1);margin-bottom:30px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-663497 .ieslide{background:rgba(243, 84, 68, 0.80);}
body.kc-css-system .kc-css-663497 strong,body.kc-css-system .kc-css-663497 a strong{color:#ffffff;font-size:25px;line-height:50px;font-family:Catamaran;padding-top:33%;padding-right:30px;padding-left:30px;}
body.kc-css-system .kc-css-663497 .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;font-family:Catamaran;background:#ffffff;margin-top:20px;padding-right:50px;padding-left:50px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-115052{box-shadow:0px 16px 50px 0px rgba(0, 0, 0, 1);margin-bottom:30px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-115052 .ieslide{background:rgba(243, 84, 68, 0.80);}
body.kc-css-system .kc-css-115052 strong,body.kc-css-system .kc-css-115052 a strong{color:#ffffff;font-size:25px;line-height:50px;font-family:Catamaran;padding-top:33%;padding-right:30px;padding-left:30px;}
body.kc-css-system .kc-css-115052 .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;font-family:Catamaran;background:#ffffff;margin-top:20px;padding-right:50px;padding-left:50px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-213588{box-shadow:0px 16px 50px 0px rgba(0, 0, 0, 1);margin-bottom:30px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-213588 .ieslide{background:rgba(243, 84, 68, 0.80);}
body.kc-css-system .kc-css-213588 strong,body.kc-css-system .kc-css-213588 a strong{color:#ffffff;font-size:25px;line-height:50px;font-family:Catamaran;padding-top:33%;padding-right:30px;padding-left:30px;}
body.kc-css-system .kc-css-213588 .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;font-family:Catamaran;background:#ffffff;margin-top:20px;padding-right:50px;padding-left:50px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-613757{box-shadow:0px 16px 50px 0px rgba(0, 0, 0, 1);margin-bottom:30px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-613757 .ieslide{background:rgba(243, 84, 68, 0.80);}
body.kc-css-system .kc-css-613757 strong,body.kc-css-system .kc-css-613757 a strong{color:#ffffff;font-size:25px;line-height:50px;font-family:Catamaran;padding-top:33%;padding-right:30px;padding-left:30px;}
body.kc-css-system .kc-css-613757 .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;font-family:Catamaran;background:#ffffff;margin-top:20px;padding-right:50px;padding-left:50px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-178978{box-shadow:0px 16px 50px 0px rgba(0, 0, 0, 1);margin-bottom:30px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-178978 .ieslide{background:rgba(243, 84, 68, 0.80);}
body.kc-css-system .kc-css-178978 strong,body.kc-css-system .kc-css-178978 a strong{color:#ffffff;font-size:25px;line-height:50px;font-family:Catamaran;padding-top:33%;padding-right:30px;padding-left:30px;}
body.kc-css-system .kc-css-178978 .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;font-family:Catamaran;background:#ffffff;margin-top:20px;padding-right:50px;padding-left:50px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-652371{box-shadow:0px 16px 50px 0px rgba(0, 0, 0, 1);margin-bottom:30px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-652371 .ieslide{background:rgba(243, 84, 68, 0.80);}
body.kc-css-system .kc-css-652371 strong,body.kc-css-system .kc-css-652371 a strong{color:#ffffff;font-size:25px;line-height:50px;font-family:Catamaran;padding-top:33%;padding-right:30px;padding-left:30px;}
body.kc-css-system .kc-css-652371 .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;font-family:Catamaran;background:#ffffff;margin-top:20px;padding-right:50px;padding-left:50px;border-radius:30px 30px 30px 30px;}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-94538{text-align:center;background:transparent url(../../assets/images/Works_bak.jpg) center center/cover no-repeat scroll;padding-top:60px;padding-bottom:60px;}
body.kc-css-system .kc-css-288710{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-6057{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-663497{text-align:center;display:inline-block;float:none;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-108394{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-115052{text-align:center;display:inline-block;float:none;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-440836{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-213588{text-align:center;display:inline-block;float:none;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-308640{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-613757{text-align:center;display:inline-block;float:none;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-816406{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-178978{text-align:center;display:inline-block;float:none;margin-right:auto;margin-left:auto;}
body.kc-css-system .kc-css-734256{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-652371{text-align:center;display:inline-block;float:none;margin-right:auto;margin-left:auto;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-288710{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-429506.ssc_btn{text-align:center;}
body.kc-css-system .kc-css-6057{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-663497{padding-top:15%;}
body.kc-css-system .kc-css-663497 strong,body.kc-css-system .kc-css-663497 a strong{padding-top:22%;}
body.kc-css-system .kc-css-108394{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-115052{padding-top:15%;}
body.kc-css-system .kc-css-115052 strong,body.kc-css-system .kc-css-115052 a strong{padding-top:22%;}
body.kc-css-system .kc-css-440836{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-213588{padding-top:15%;}
body.kc-css-system .kc-css-213588 strong,body.kc-css-system .kc-css-213588 a strong{padding-top:22%;}
body.kc-css-system .kc-css-308640{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-613757{padding-top:15%;}
body.kc-css-system .kc-css-613757 strong,body.kc-css-system .kc-css-613757 a strong{padding-top:22%;}
body.kc-css-system .kc-css-816406{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-178978{padding-top:15%;}
body.kc-css-system .kc-css-178978 strong,body.kc-css-system .kc-css-178978 a strong{padding-top:22%;}
body.kc-css-system .kc-css-734256{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-652371{padding-top:15%;}
body.kc-css-system .kc-css-652371 strong,body.kc-css-system .kc-css-652371 a strong{padding-top:22%;}
}

</style>



// WEBPACK FOOTER //
// src/components/Blocks/Works.vue